import React, { ReactElement } from 'react'

export function AuthWrapper({ children }: { children: React.ReactNode }): ReactElement {
  return <div className="bg-secondary text-foreground">{children}</div>
}
